import React from 'react';
import bgImage from '../../assets/images/backgrounds/background_culture.png';
import TextContentHeader from './TextContentHeader';
import TextContentInner from './TextContentInner';
import { CareersContentData } from '../../Data/CareersContent';

function CareersContent() {
  return (
    <div className="text-content">
      <div
        className="text-content-wrapper position-relative bg-black"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <TextContentHeader heading="Work That Creates Meaningful Impact" />
        <TextContentInner content={CareersContentData} />
      </div>
    </div>
  );
}

export default CareersContent;